<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">Allowance calculation (ID: {{ allowance.id }})</h1>
        <div class="status-title" :style="{ 'backgroundColor': allowance.status.color || '#8a8a8a' }">
          {{ allowance.status.name }}
        </div>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Month:</span>
              <span>{{ dateFormat(allowance.month) }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Drivers:</span>
              <span>{{ allowance.drivers }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>KM:</span>
              <span>{{ allowance.km.toLocaleString() }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Amount:</span>
              <span>{{ allowance.amount.toLocaleString() }} TSh</span>
            </div>
          </div>
        </div>
      </div>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__driver><div class="table-default__left">Driver</div></template>
        <template #driver="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'employees-profile', params: { id: row.employee_month.employee.id } }"
              class="table-default__link-border"
            >
              {{ row.employee_month.employee.full_name }}
            </router-link>
          </div>
        </template>
        <template #basic_km="{ row }">{{ row.basic_km.toLocaleString() }}</template>
        <template #km="{ row }">
          <template v-if="allowance.status.code === 'approved'">{{ row.km }}</template>
          <app-input
            v-if="allowance.status.code === 'wait'"
            @change.native="onPatchDriverAllowanceEmployee(row.id, $event.target.value)"
            v-model.number="row.km"
            type="number"
            placeholder="0"
            autocomplete="off"
            id="allowance_km"
            class="input--150 input--center"
            name="allowance_km"
            @paste.native.prevent
          />
        </template>
        <template #amount="{ row }">{{ row.amount.toLocaleString() }} TSh</template>
      </v-client-table>
      <app-cells>
        <app-button
          v-if="allowance.status.code === 'wait' && (is_general_manager || is_transfer_supervisor || is_transfer_manager)"
          @click.native="onPatchDriverAllowance({ status: 'approved' })"
          ref="patch"
        >
          Approved
        </app-button>
      </app-cells>
    </template>
  </div>
</template>

<script>
import {
  getEmployeesDriverAllowance,
  getEmployeesDriverAllowanceEmployeesList,
  patchEmployeesDriverAllowance,
  patchEmployeesDriverAllowanceEmployees
} from '@/http'
import { format, parse } from 'date-fns'

export default {
  name: 'TransferAllowanceDetail',
  data() {
    return {
      is_loaded: false,
      allowance: {},
      table_preloader: false,
      table: {
        items: [],
        columns: ['driver', 'basic_km', 'rate_per_km', 'km', 'amount'],
        options: {
          headings: {
            driver: 'Driver',
            basic_km: 'Basic KM',
            rate_per_km: 'Rate per KM',
            km: 'KM',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_transfer_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('transfer_supervisor')
    },
    is_transfer_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('transfer_manager')
    },
  },
  created() {
    this.getAllowanceData()
    this.getDriverAllowanceEmployeesList()
  },
  methods: {
    onPatchDriverAllowance(data) {
      this.$refs.patch.preload = true
      patchEmployeesDriverAllowance(this.$route.params.id, data)
        .finally(() => { this.$refs.patch.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Status changed',
          })
          this.getAllowanceData()
          this.getDriverAllowanceEmployeesList()
        })
    },
    onPatchDriverAllowanceEmployee(employee_id, km_value) {
      this.table_preloader = true
      patchEmployeesDriverAllowanceEmployees(this.$route.params.id, employee_id, { km: +km_value })
        .finally(() => { this.table_preloader = false })
        .then(() => {
          this.getDriverAllowanceEmployeesList()
        })
    },
    getAllowanceData() {
      getEmployeesDriverAllowance(this.$route.params.id)
        .then(res => {
          this.allowance = res.data
          this.is_loaded = true
        })
    },
    getDriverAllowanceEmployeesList() {
      this.table_preloader = true
      getEmployeesDriverAllowanceEmployeesList(this.$route.params.id)
        .then(res => {
          this.table.items = res.data
          this.table_preloader = false
        })
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM yyyy')
    },
  }
}
</script>
